<template>
  <div>
    <ul class="app_list" style="border-top: 0">
      <li class="app_item" v-for="(item, index) in approvalList" :key="index">
        <div class="clearfix">
          <author-portrait
            :creater="item.assigneeName"
            class="left"
          ></author-portrait>
          <div class="clearfix left">
            <div class="left mal5">
              <span class="name">{{ item.assigneeName }}</span>
              <div :class="handleStatusClass(item)" class="mat3">
                <i :class="handleStatus(item)" class="mar5"></i>
                <span class="status">{{ handleApprovalstatus2(item) }}</span>
              </div>
            </div>
            <div class="left asymptotic" v-if="index < approvalList.length - 1">
              &gt;&gt;
            </div>
          </div>
        </div>
        <div class="time mat10">
          {{ item.updateTime }}
        </div>
      </li>
    </ul>
    <!-- 审批意见 -->
    <ul>
         <li class="reason_item" v-for="(item, index) in approvalList" :key="index">
             <template v-if="item.reason">
                <span class="name">{{ item.assigneeName }}:</span>
                <span>{{item.reason}}</span>
             </template>
         
         </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ApprovalProcess",
  props: {
      approvalList: {
          type: Array,
          default: ()=>{
              return []
          }
      },
  },
  methods: {
      // 处理类名显示
      handleStatusClass(item) {
        if (item.status === 0) {
          return 'step_check'
        }
        if (item.status === 1) {
          return 'step_success'
        }
        if (item.status === 2) {
          return 'step_error'
        }
        if (item.flag === 1) {
          return 'step_success'
        }
      },
      // 处理图标显示状态
      handleStatus(item) {
        if (item.status === 0) {
          return 'el-icon-s-check'
        }
        if (item.status === 1) {
          return 'el-icon-success'
        }
        if (item.status === 2) {
          return 'el-icon-error'
        }
        if (item.flag === 1) {
          return 'el-icon-success'
        }
      },
      handleApprovalstatus2(item) {
        if (item.flag === 1) {
          return '发起人'
        }
        if (item.status === 0) {
          return '待审批'
        }
        if (item.status === 1) {
          return '已确认'
        }
        if (item.status === 2) {
          return '已驳回'
        }
      },
  },
};
</script>

<style lang="scss" scoped>
  .app_list {
    width: 100%;
    border-top: 2px solid #ebeef5;
    padding: 20px 0;

    .app_item {
      display: inline-block;
      min-width: 120px;
      margin-right: 30px;
      margin-top: 10px;

      .name {
        font-size: 14px;
        color: #001111;
      }

      .time {
        font-size: 13px;
        color: #999999;
        height: 11px;
      }

      .asymptotic {
        color: #999;
        font-size: 14px;
        line-height: 40px;
        margin-left: 30px;
      }

      .status {
        font-size: 13px;
        color: #828282;
      }

      .step_check {
        .el-icon-s-check {
          color: #999999;
        }
      }

      .step_success {
        .el-icon-success {
          color: #35ac00;
        }
      }

      .step_error {
        .el-icon-error {
          color: #ff0000;
        }
      }
    }
  }
  .reason_item{
      line-height: 28px;
  }
</style>